import React from 'react';
import { Stepper, Step, StepLabel, StepContent } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import FormQuestions from './FormQuestions';

const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%',
        //backgroundColor : "#EEEFF2"
    },
    labelQuestion: {
        //fontFamily: 'MyriadPro-Bold'
    },
    stepper: {
        "& .MuiStepIcon-active": {
            color: '#372d2d'
            //display: "none"
        },
        "& .MuiStepLabel-label": {
            //fontFamily: 'MyriadPro-Bold'
        },
    },
}));

const StepperQuestions = props => {

    const {
        activeStep,
        steps,
        orientation,
        handleNext,
        question,
        answer,
        dataquestions,
        handleChangeQuestion,
        handleChangeAnswer,
        handleBack,
        formErrors,
        type,
        setType
    } = props;

    const classes = useStyles();
    /*console.log(steps)
    console.log(question)
    console.log(dataquestions)*/
    return (
        <div className={classes.root}>
            <Stepper activeStep={activeStep} orientation={orientation} className={classes.stepper}>

                {steps.map((item, index) => (
                    <Step key={index}>
                        <StepLabel /* className={classes.labelQuestion} */ >{item.title}</StepLabel>
                        <StepContent>
                            <FormQuestions
                                handleNext={handleNext}
                                handleBack={handleBack}
                                question={question}
                                answer={answer}
                                dataquestions={dataquestions}
                                handleChangeQuestion={handleChangeQuestion}
                                handleChangeAnswer={handleChangeAnswer}
                                activeStep={activeStep}
                                formErrors={formErrors}
                                type={type}
                                setType={setType}
                                sizeSteps={steps.length}
                                index={index}
                            />
                        </StepContent>
                    </Step>
                ))}

            </Stepper>
        </div>
    );
}

export default StepperQuestions;